// extracted by mini-css-extract-plugin
export var breakText = "styles-module--break-text--afb8b";
export var cardRichText = "styles-module--card-rich-text--b2734";
export var mobileTitle = "styles-module--mobile-title--20e63";
export var paragraphSpacing = "styles-module--paragraph-spacing--fda9f";